import {Formik} from "formik";
import {Key, Mail} from "react-feather";
import {useTheme} from "styled-components";
import {Fragment} from "react/jsx-runtime";
import {login} from "global/slices/auth/thunks";
import {useAppDispatch, useBreakpoints} from "hooks";
import {LocalPoliceOutlined} from "@mui/icons-material";
import {loginSchema, initialValues} from "./form.schema";
import {Container, Welcome, Information, Layout} from "./styled";
import {
  Row,
  Input,
  Image,
  Column,
  Button,
  Typography,
  InputPassword,
} from "components";

interface LoginProps {}

export const Login: React.FC<LoginProps> = () => {
  const dispatch = useAppDispatch();
  const {downMd} = useBreakpoints();
  const {container, black, blackWhite} = useTheme();

  return (
    <Layout>
      <Container>
        <Welcome>
          <Information>
            <Image
              width={300}
              height={60}
              objectFit="contain"
              src="/images/logo-horizontal.png"
            />
            {downMd ? (
              <Fragment />
            ) : (
              <Column width="100%" alignItems="center" gap={0}>
                <Typography
                  color={black}
                  textAlign="center"
                  fontSize={downMd ? 18 : 22}
                  fontFamily="Rubik-Medium"
                >
                  Panel Administrativo
                </Typography>
              </Column>
            )}
            {!downMd && (
              <Typography color={black} fontSize={14} textAlign="center">
                © Todos los derechos reservados, {new Date().getFullYear()}
              </Typography>
            )}
          </Information>
        </Welcome>
        <Column
          gap={5}
          alignItems="center"
          backgroundColor={container}
          padding={downMd ? "1rem" : "2rem"}
          justifyContent={downMd ? "flex-start" : "center"}
        >
          <Row width="100%" marginBottom={10}>
            <LocalPoliceOutlined style={{color: blackWhite}} />
            <Typography fontSize={22} fontFamily="Rubik-SemiBold">
              Bienvenido, Inicia Sesión
            </Typography>
          </Row>
          <Formik
            initialValues={initialValues}
            validationSchema={loginSchema}
            onSubmit={(payload) => {
              dispatch(login(payload));
            }}
          >
            {({
              dirty,
              errors,
              isValid,
              touched,
              handleBlur,
              handleSubmit,
              handleChange,
            }) => {
              const isDisabled = !(dirty && isValid);
              return (
                <Column width="100%">
                  <Input
                    autoFocus
                    icon={Mail}
                    name="email"
                    type="email"
                    label="Correo"
                    touched={touched["email"]}
                    onBlur={handleBlur("email")}
                    onChange={handleChange("email")}
                    placeholder="administrador@fumdes.com"
                    helperErrorText={errors["email"]}
                  />
                  <InputPassword
                    icon={Key}
                    name="password"
                    touched={touched["password"]}
                    onBlur={handleBlur("password")}
                    label="Contraseña"
                    onChange={handleChange("password")}
                    placeholder="Contraseña"
                    helperErrorText={errors["password"]}
                  />
                  <Column width="100%" alignItems="center" marginTop={10}>
                    <Button
                      type="submit"
                      loaderId="login"
                      disabled={isDisabled}
                      style={{width: "100%"}}
                      label="Iniciar sesión"
                      onClick={() => handleSubmit()}
                    />
                  </Column>
                </Column>
              );
            }}
          </Formik>
        </Column>
      </Container>
    </Layout>
  );
};
